import React, { PropTypes } from 'react'
import moment from 'moment';
import Avatar from 'components/Avatar/Avatar';
import { CPDPoints } from 'components/CPDPoints';

const UpcomingWebinarItem = ({
    webinar: {
      webinar_title,
      start_date,
      end_date,
      expert_name,
      doctor_type,
      work_location,
      sponsor,
      doctor_avatar_url,
      subscription_id,
      job_code_dashboard,
      job_code_home_page
    },
    userRole,
    webinar,
    toggleSubscription
  }) => {
  return (
    <div className="col s12 m6 l4">
      <div className="container_section_current">
        <div className="section_current clearfix-c">
          <div className="section_current_card">
            <p className="current_card_date">
              <span>{moment(start_date).format('MMM DD').toUpperCase()} </span>
              {moment(start_date).format('YYYY')}
            </p>
            <p className="current_card_time">
              {moment(start_date).format('h:mm a').toUpperCase()}
              {' - '}{moment(end_date).format('h:mm a').toUpperCase()}
            </p>
          </div>
          <div className="current_card_topic clearfix-c">
            <p className="current_card_topic_title"></p>
            <p className="current_card_topic_management">{webinar_title}</p>
            <span className="section_logo">{sponsor && sponsor.logo_url && <img src={sponsor.logo_url} alt="logo"/>}</span>
            <p className="sponsor_title">{(sponsor && `Sponsored by: ${sponsor.title}`) || 'N/A'}</p>
          </div>
          <div className="current_person clearfix-c">
            <div className="current_person_photo">
              <Avatar size={55} name={expert_name} src={doctor_avatar_url}/>
            </div>
            <div className="current_person_name">
              <p>{expert_name}</p>
            </div>
            <div className="current_person_description">
              <p>{`${doctor_type}`}・{work_location}</p>
            </div>
          </div>

        </div>
        <div className="section_webinars_bottom">
          <div>
            <div className="current_join">
              { ['sponsor'].indexOf(userRole) === -1 &&
                <a href="javascript:void(0)" onClick={toggleSubscription}>
                  {subscription_id ? 'DE-REGISTER INTEREST' : 'REGISTER INTEREST'}
                </a>
              }
            </div>
            {webinar.ext_cpd_points === 0 && webinar.int_cpd_points === 0 ? null :
              <div className="current_points">
                <CPDPoints webinar={webinar} />
              </div>
            }
          </div>
          <div className="click_register">
            <p>
              For all webinars, you will receive an email reminder 1 hour before they start. Click “Register Interest” to receive another email reminder 24 hours beforehand.
            </p>
          </div>
          <div className="job_code">
            { userRole && job_code_dashboard ? ( <p>Job code: {job_code_dashboard}</p>):null}
            { !userRole && job_code_home_page ? ( <p>Job code: {job_code_home_page}</p>):null}
          </div>
        </div>
      </div>
    </div>
  )
}

UpcomingWebinarItem.propTypes = {
  webinar: PropTypes.obj,
  toggleSubscription: PropTypes.obj,
  userRole: PropTypes.string
}

export default UpcomingWebinarItem



/** WEBPACK FOOTER **
 ** ./src/components/Dashboard/UpcomingWebinars/UpcomingWebinarItem.js
 **/